import angular from 'angular';
import constants from 'app/constants';
import {
  amDataService,
  amSharedModelService,
  loaderService,
  orgDataService,
  ssDialogService,
  reportsDataService,
} from 'app/services';
import {
  alerts,
  confirmDialog,
} from 'app/components/global';
import editAuditDialog from '../../dialog.editAuditDialog';
import markAuditCompleteConfirmDialog from '../dialog.markAuditCompleteConfirmDialog';
import controller from './active-audit.controller';
import directive from './active-audit.directive';
import findingCategories from '../findingCategories';
import recommendationCategories from '../recommendationCategories';
import preparationItemCategories from '../preparationItemCategories';

export default angular
  .module('app.components.advisory.auditTrail.activeAudit', [
    alerts,
    amDataService,
    amSharedModelService,
    confirmDialog,
    constants,
    loaderService,
    ssDialogService,
    orgDataService,
    reportsDataService,
    findingCategories,
    recommendationCategories,
    preparationItemCategories,
    editAuditDialog,
    markAuditCompleteConfirmDialog,
  ])
  .directive('amActiveAudit', directive)
  .controller('ActiveAuditController', controller).name;

console.log('app.components.advisory.auditTrail.activeAudit created');
